import React from 'react';
import PublicLeadForm from '../components/PublicLeadForm';

const PublicLeadPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <PublicLeadForm />
      </div>
    </div>
  );
};

export default PublicLeadPage;
